import { Typography } from '@mui/material';
import { AttentionIcon, ModalContent } from '@schooly/style';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface CloseAccountInfoProps {
  id?: any;
}

export const CloseAccountInfo: React.FC<CloseAccountInfoProps> = () => {
  return (
    <ModalContent active>
      <Typography variant="h2">
        <FormattedMessage id="login-ThisActionWill" />
      </Typography>
      <Typography variant="h3" color="text.primary">
        <ul>
          <li>
            <FormattedMessage id="login-DeleteProfiles" />
          </li>
          <li>
            <FormattedMessage id="login-DeleteYourOwn" />
          </li>
        </ul>
      </Typography>

      <Typography variant="h2">
        <FormattedMessage id="login-ThisActionWillNot" />
      </Typography>
      <Typography variant="h3" color="text.primary">
        <ul>
          <li>
            <FormattedMessage id="login-DeleteSchoolRecords" />
          </li>
          <li>
            <FormattedMessage id="login-DeleteFamilyMembers" />
          </li>
        </ul>
      </Typography>
      <Typography variant="h3" color="error.main">
        <AttentionIcon /> <FormattedMessage id="login-ThisAction" />
      </Typography>
    </ModalContent>
  );
};
